/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for domain availability check
 * @export
 * @interface DomainAvailabilityResponse
 */
export interface DomainAvailabilityResponse {
    /**
     * Whether the domain is available
     * @type {boolean}
     * @memberof DomainAvailabilityResponse
     */
    available?: boolean;
    /**
     * Domain being checked
     * @type {string}
     * @memberof DomainAvailabilityResponse
     */
    domain?: string;
    /**
     * Reason if domain is not available
     * @type {string}
     * @memberof DomainAvailabilityResponse
     */
    reason?: string;
    /**
     * Whether domain is commercial
     * @type {boolean}
     * @memberof DomainAvailabilityResponse
     */
    isCommercial?: boolean;
    /**
     * Suggested alternative domains if not available
     * @type {Array<string>}
     * @memberof DomainAvailabilityResponse
     */
    suggestedAlternatives?: Array<string>;
}

/**
 * Check if a given object implements the DomainAvailabilityResponse interface.
 */
export function instanceOfDomainAvailabilityResponse(value: object): value is DomainAvailabilityResponse {
    return true;
}

export function DomainAvailabilityResponseFromJSON(json: any): DomainAvailabilityResponse {
    return DomainAvailabilityResponseFromJSONTyped(json, false);
}

export function DomainAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainAvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'isCommercial': json['is_commercial'] == null ? undefined : json['is_commercial'],
        'suggestedAlternatives': json['suggested_alternatives'] == null ? undefined : json['suggested_alternatives'],
    };
}

export function DomainAvailabilityResponseToJSON(json: any): DomainAvailabilityResponse {
    return DomainAvailabilityResponseToJSONTyped(json, false);
}

export function DomainAvailabilityResponseToJSONTyped(value?: DomainAvailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'domain': value['domain'],
        'reason': value['reason'],
        'is_commercial': value['isCommercial'],
        'suggested_alternatives': value['suggestedAlternatives'],
    };
}

